module.exports = __webpack_public_path__ + "static/media/Shopping.8db79ee7.png";